export default "__VITE_ASSET__BDOLStzb__"